/**
 * Ecosystem Account
 * One account (e.g. secured with Google) used across TD1 World, Karma AC, Realm, Mindaloo.
 * Plan limits and Karma balance are at account level; each AI/profile knows its cap from this.
 */

import type { SubscriptionPlan } from "@/lib/subscription/plans";

/** External ecosystem identifiers – link same person across products */
export interface EcosystemIdentity {
  /** TD1 World user id (when linked) */
  td1WorldId?: string;
  /** Karma AC user id (when linked) */
  karmaAcId?: string;
  /** Realm user id (when linked) */
  realmId?: string;
  /** Google (or other OAuth) id – primary securable identity */
  googleId?: string;
  /** When this account was last synced with an ecosystem service */
  linkedAt?: number;
}

/**
 * Account – one per user across the ecosystem.
 * Id is stable (e.g. from auth); plan drives limits; karmaBalance for "Pay in Karma" (Karma Coin / Ethereum).
 */
export interface Account {
  /** Same as userId from auth / getUserId() */
  id: string;
  /** Subscription plan – drives message/api/file/media caps */
  plan: SubscriptionPlan;
  /** Karma balance (Karma Coin units – Ethereum link TBD) for top-ups and pay-in-karma */
  karmaBalance: number;
  /** Ecosystem ids so TD1 World, Karma AC, Realm all resolve to this account */
  ecosystem?: EcosystemIdentity;
  createdAt: number;
  updatedAt: number;
}

/** Default plan when creating a new account */
export const DEFAULT_ACCOUNT_PLAN: SubscriptionPlan = "free";

/** Default Karma balance for new accounts */
export const DEFAULT_KARMA_BALANCE = 0;
